<template>
  <ProSpaceRightPanel
    class="workflow-panel"
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @edit="editPanel"
    @resetPassword="resetPasswordPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerNotification">
        <ProSpacePanelBlockList :list="content" />
        <ProSpaceSimpleGrid
          :headers="listHeaders"
          :service="secondService"
          getMethod="getByWorkflowId"
          propId="workflowSettingId"
          defaultSortField="stepNo"
          :id="id"
          :key="id"
          :btnText="$t('viewMore')"
        />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
  ProSpacePanelBlockHeader,
  ProSpacePanelBlockItem,
  ProSpaceSimpleGrid,
} from "@prospace/prospace-components-library";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "WorkflowPanel",
  components: {
    ProSpaceRightPanel,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
    ProSpacePanelBlockHeader,
    ProSpacePanelBlockItem,
    ProSpaceSimpleGrid,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
    secondService: {
      type: Object,
      required: true,
    },
    ids: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      workflow: null,
      header: {},
      options: this.options,
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime"
    }),
    headerNotification() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    listHeaders() {
      return [
        {
          name: "Step",
          value: "stepNo",
          f: (item) => {
            return Number(item);
          },
        },
        { name: "Name", value: "name" },
      ];
    },
    header() {
      if (this.workflow) {
        return {
          title: this.workflow.name,
          id: this.ids[0],
          status: this.getStatus(this.workflow.status),
          showCounter: false,
          options: this.options,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        options: this.options,
      };
    },
    content() {
      if (this.workflow) {
        return [
          [
            {
              title: this.$t("description"),
              text: this.workflow.description,
            },
          ],
          [
            {
              title: this.$t("version"),
              text: this.workflow.version,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.workflow) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.workflow.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.workflow.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.workflow.createdAt) + ' ' + getAMorPM(this.workflow.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.workflow.lastUpdated) + ' ' + getAMorPM(this.workflow.createdAt, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    async update() {
      this.hasError = false;
      try {
        this.workflow = await this.getWorkflow();
      } catch (e) {
        this.hasError = true;
      }
    },
    async getWorkflow() {
      if (this.ids.length === 1) {
        this.loading = true;
        const res = await this.service.get(this.ids[0]);
        this.loading = false;
        return res.data;
      }
      return null;
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      switch (status.toLowerCase()) {
        case "complete":
          type = "success";
          break;
        case "active":
          type = "success";
          break;
        case "draft":
          type = "info";
          break;
        case "process":
          type = "warning";
          break;
        case "error":
          type = "danger";
          break;
        default:
          type = "default";
      }
      return {
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
        type,
      };
    },
    editPanel() {
      this.$emit("edit", this.workflow);
    },
    deletePanel() {
      this.$emit("delete-item", this.workflow);
    },
    showHistoryPanel() {
      this.$emit("history-item", this.workflow);
    },
  },
};
</script>

<style lang="scss" scoped>
.workflow-panel {
}
</style>
